<template>
    <app-primary>
        <template #subHead>
            <sub-visual sh="Media">
                <template #titHead>M</template>
                <template #tit>edia</template>
            </sub-visual>
        </template>
        <page-section class="page-section--first page-section--last">
            <press-list />
        </page-section>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubVisual from "@/sets/styles/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import PressList from "@/components/client/press/press-list.vue";

export default {
    components: {
        AppPrimary,
        SubVisual,
        PageSection,
        PressList,
    },
};
</script>

<style lang="scss" scoped></style>
